import { Container, Row, Col } from 'react-bootstrap';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';
import { breadcrumbsLinks } from '../../../../../constants/Constants';

const FAQs = () => {
  return (
    <Container className="main-container p-0">
      <Row>
        <Col xs={12} md={8}>
          <Breadcrumbs links={breadcrumbsLinks.faqs} />
          <h3 className="main-heading" data-testid="FAQs">
            FAQs
          </h3>
          <div className="main-content">
            <p>Content to be developed at a later stage</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FAQs;
